import { Button, Group, Modal, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

type ProductStarLoginModalProps = {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  accentColor?: string;
  zIndex?: number;
};

export function ProductStarLoginModal({
  opened,
  onClose,
  onConfirm,
  accentColor,
  zIndex,
}: ProductStarLoginModalProps) {
  const { t } = useTranslation();

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={t('marketplace.productViewer.starLoginTitle')}
      centered
      zIndex={zIndex}
    >
      <Text size="sm">{t('marketplace.productViewer.starLoginMessage')}</Text>
      <Group justify="flex-end" mt="md">
        <Button variant="default" onClick={onClose}>
          {t('marketplace.productViewer.starLoginCancel')}
        </Button>
        <Button color={accentColor} onClick={onConfirm}>
          {t('marketplace.productViewer.starLoginConfirm')}
        </Button>
      </Group>
    </Modal>
  );
}
